export enum AccessRightCodes {
  SysAdmin_All = "SysAdmin.All",
  Core_HumanResources_Employee_Read = "Core.HumanResources.Employee.Read",
  Core_HumanResources_Employee_Edit = "Core.HumanResources.Employee.Edit",
  Core_HumanResources_ExternalSuppliers_Read = "Core.HumanResources.ExternalSuppliers.Read",
  Core_HumanResources_ExternalSuppliers_Edit = "Core.HumanResources.ExternalSuppliers.Edit",
  Core_Users_Read = "Core.Users.Read",
  Core_Users_Edit = "Core.Users.Edit",
  Core_Company_Supplier_Read = "Core.Company.Supplier.Read",
  Core_Company_Supplier_Edit = "Core.Company.Supplier.Edit",
  Core_Company_Customer_Read = "Core.Company.Customer.Read",
  Core_Company_Customer_Edit = "Core.Company.Customer.Edit",
  Core_AccessRoles_Read = "Core.AccessRoles.Read",
  Core_AccessRoles_Edit = "Core.AccessRoles.Edit",
  Core_Dashboard_Read = "Core.Dashboard.Read",
  Core_Guidepost_Read = "Core.Guidepost.Read",
  Core_InvoiceItemCategories_Read = "Core.InvoiceItemCategories.Read",
  Core_InvoiceItemCategories_Edit = "Core.InvoiceItemCategories.Edit",
}
